import { getRequest } from '../services/requestHandler';
import { HeadFinish } from '../models';

// Note: only '5' returns any data
export const getHeadFinishes = async (headTypeId = 0) => {
  const url = `head/getHeadFinishes?headTypeId=${headTypeId}&activeOnly=true`;
  const response = await getRequest<HeadFinish>('GetHeadFinishes', url);
  return response;
};
